import { OnlineProduct } from '../shopify/types/OnlineProduct';

export type ShopifyGetProductsOptions = {
  shouldExcludeMarketplaceProducts?: boolean;
  numberOfProducts?: number;
};

export type GetStoreRequest = {
  longitude: number;
  latitude: number;
};

export type GetStoreResponse = {
  data: {
    locations: {
      nodes: Array<{
        id: string;
        name: string;
        storeId: { value: string };
      }>;
    };
  };
};

export type SetPreferredStoreResponse = {
  data?: {
    cart: {
      buyerIdentity: {
        preferences?: {
          delivery: {
            deliveryMethod: Array<string>;
            pickupHandle: Array<string>;
          };
        };
      };
    };
  };
  userErrors?: {
    field: string;
    code: number;
    message: string;
  };
};

export type GetProductResponse = {
  data: {
    product: {
      id: string;
      variants: {
        nodes: Array<{
          id: string;
          sku: string;
          price: {
            amount: string;
          };
        }>;
      };
    };
  };
};

export type GetProductsByVariantIdResponse = {
  products: Array<{ id: string; handle: string; metafields: { onlineProduct: OnlineProduct } }>;
};

export type GetProductHandlesBySkuResponse = {
  products: Array<{ id: string; handle: string; sku: string }>;
};

export type GetSellerMetaobjectResponse = {
  data: {
    metaobject: {
      seller_id: { value: string };
      name: { value: string };
      url_handle: { value: string };
      is_digital_invoice_provided: { value: boolean };
    };
  };
};

export type DiscountApplication = {
  discountedAmount: {
    amount: string;
    currencyCode: string;
  };
};

export type StorefrontCart = {
  id: string;
  totalQuantity: number;
  cost: {
    totalAmount: {
      amount: string;
      currencyCode: string;
    };
    subtotalAmount: {
      amount: string;
      currencyCode: string;
    };
  };
  buyerIdentity: {
    preferences: {
      delivery: {
        deliveryMethod: Array<string>;
        pickupHandle: Array<string>;
      };
    };
  };
  discountAllocations: Array<DiscountApplication>;
  attributes: Array<{
    key: string;
    value: string;
  }>;
  lines: {
    edges: Array<{
      node: {
        id: string;
        quantity: number;
        discountAllocations?: Array<{
          discountedAmount: {
            amount: string;
            currencyCode: string;
          };
        }>;
        merchandise: {
          id: string;
          sku: string;
          image: {
            url: string;
          };
          product: {
            id: string;
            title: string;
            handle: string;
            productType: string;
            vendor: string;
            onlineProduct: {
              value: string;
            };
          };
        };
        parentRelationship?: {
          parent: {
            id: string;
          };
        };
        attributes: Array<{
          key: string;
          value: string;
        }>;
        cost: {
          totalAmount: {
            amount: string;
            currencyCode: string;
          };
          subtotalAmount: {
            amount: string;
            currencyCode: string;
          };
        };
      };
    }>;
  };
};

export const cartGQLObject = `
  id
  totalQuantity
  cost {
    totalAmount {
      amount
      currencyCode
    }
    subtotalAmount {
      amount
      currencyCode
    }
  }
  discountAllocations {
    discountedAmount {
      amount
      currencyCode
    }
  }
  buyerIdentity {
    customer {
      email
      id
    }
    preferences {
      delivery {
        deliveryMethod
        pickupHandle
      }
    }
  }
  attributes {
    key
    value
  }
  lines(first: 250) {
    edges {
      node {
        id
        quantity
        discountAllocations {
          discountedAmount {
            amount
            currencyCode
          }
        }
        merchandise {
          ... on ProductVariant {
            id
            sku
            image {
              url
            }
            product {
              id
              title
              handle
              productType
              vendor
              onlineProduct: metafield(namespace: "online_product", key: "value") {
                value
              }
            }
          }
        }
        ... on CartLine {
          parentRelationship {
            parent {
              id
            }
          }
        }        
        attributes {
          key
          value
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
        }
      }
    }
  }
`;
